import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

const splitHeadingLetters = (text) =>
  text.split('').map((character, index) => (
    <span
      key={`${text}-${index}`}
      className={`privacy-heading-letter${character === ' ' ? ' is-space' : ''}`}
      style={{ '--letter-index': index }}
      aria-hidden="true"
    >
      {character === ' ' ? '\u00A0' : character}
    </span>
  ));

const PrivacyPolicyPage = () => {
  const [isHeadingVisible, setIsHeadingVisible] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setIsHeadingVisible(true);
    }, 80);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <div className="privacy-policy-page-wrapper">
      <div className="privacy-policy-page-container privacy-policy-page">
        <div className="privacy-policy-back-link">
          <Link to="/">&larr; Back to Home</Link>
        </div>

        <div className="privacy-policy-page-hero">
          <h1
            className={`privacy-heading ${isHeadingVisible ? 'is-visible' : ''}`}
            aria-label="Privacy Policy"
          >
            {splitHeadingLetters('Privacy Policy')}
          </h1>
          <p>
            At BlackRoth, protecting your privacy is a top priority. This Privacy
            Policy outlines how we collect, use, store, and safeguard your
            information when you interact with our platform, services, and
            digital properties.
          </p>
        </div>

        <section className="privacy-policy-page-section">
          <h2 className="privacy-section-heading">Information We Collect</h2>
          <p>
            We may collect personal details such as your name, email address,
            organization data, and usage activity when you register, access, or
            interact with our services. This information helps us deliver secure,
            personalized, and efficient platform experiences.
          </p>
        </section>

        <section className="privacy-policy-page-section">
          <h2 className="privacy-section-heading">How We Use Information</h2>
          <p>
            Collected data is used to operate services, improve system
            performance, enhance user experience, and communicate important
            updates. We ensure all usage aligns with regulatory requirements and
            legitimate business purposes.
          </p>
        </section>

        <section className="privacy-policy-page-section">
          <h2 className="privacy-section-heading">Data Protection &amp; Storage</h2>
          <p>
            BlackRoth implements enterprise-grade security controls, encryption
            standards, and access restrictions to protect stored information.
            Data is maintained within secure infrastructures designed to prevent
            unauthorized access, loss, or misuse.
          </p>
        </section>

        <section className="privacy-policy-page-section">
          <h2 className="privacy-section-heading">User Rights &amp; Choices</h2>
          <p>
            Users retain rights over their personal data, including access,
            correction, and deletion requests where applicable. We provide
            transparent mechanisms to manage privacy preferences and ensure
            compliance with global data protection frameworks.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
